/// <reference types="node" />
export const environment = {
  production: true,
  locale: 'da-DK',
  sentry: {
    DSN: 'https://5dacfd4b26a142bcbf1a3bbacf4db121@o4504288101728256.ingest.sentry.io/4504367019655168',
    environment: 'Stage',
    enabled: true,
  },
  algolia: {
    algoliaProxy: 'algolia.supervin.io',
    wineFestivalIndexName: 'Products_dk_VF'
  },
  supervin: {
    api: (process.env['SUPERVIN_MAGENTO_HOSTNAME'] ?? 'https://dk.magento.supervin.io') + '/',
    graphQLPath: 'efiware/page/graphql',
    storyblokPath: 'storyblok/storyblok/story',
    assets: process.env['SUPERVIN_MAGENTO_HOSTNAME'] ?? 'https://dk.magento.supervin.io',
    '360ImageUrl': 'https://360images.supervin.io',
    persistentCache: true,
    frontendHostname: process.env['SUPERVIN_FRONTEND_HOSTNAME'] ?? 'www.dk.supervin.io',
    previewHostname: process.env['SUPERVIN_PREVIEW_HOSTNAME'] ?? 'preview.dk.supervin.io',
    showPowerStop: true,
    showAgeVerificationPopup: false,
    disableGiftcards: false,
    hideGroupVoucher: false,
    showB2B: true,
    showDagensVin: true,
  },
  checkout: {
    defaultCountry: 'DK',
    countryList: ['SE', 'NO', 'DK'],
    disableCityField: true,
    allowB2BCheckout: true,
  },
  superpay: {
    enabled: true,
    enabledCheckout: true,
    domain: 'supervin',
    lang: 'da',
    api: 'https://sp-checkout-widget-git-ready-for-sweeden-superpayv2.vercel.app',
    graphql: 'https://5flxygi5pd.execute-api.eu-central-1.amazonaws.com/prod/graphql'
  },
  cookiebot: {
    id: '28a2fb20-99d0-43e3-8205-2676b0e4ae12',
  },
  GTM: {
    id: 'GTM-KTHS2PG'
  },
  storyblok: {
    enforceDraft: false,
    public_accessToken: 'D93fLvpmzlnRouQV8QqBGwtt',
    languageSlug: ''
  },
  oneSignal: {
    appId: '738acab5-5de7-41f0-8c1b-e2a71620f102'
  },
  cvrapi: {
    url: 'https://cvrapi.dk/api',
  },
  trustpilot: {
    enabled: true,
    locale: 'da-DK',
    businessunitId: '488898fc00006400050306c7',
    reviewPageUrl: 'https://dk.trustpilot.com/review/www.supervin.dk',
    widgets: {
      carousel: {
        templateId: '53aa8912dec7e10d38f59f36',
        token: '5c5901c8-4bb0-4bbf-8da9-30effde527a3',
        stars: '4,5',
        reviewLanguages: 'da'
      },
      mini: {
        templateId: '5419b757fa0340045cd0c938',
        token: 'a7c484ed-99cc-4f31-9d42-27a74f5a5ec6'
      },
      miniDark: {
        templateId: '53aa8807dec7e10d38f59f32',
        token: 'f9199170-5848-4745-9ced-7b873043a3a1'
      },
      horizontal: {
        templateId: '5406e65db0d04a09e042d5fc',
        token: 'b1089d42-7188-439b-b3d7-f795f21fd164'
      }
    }
  },
  tryggEhandel: {
    enabled: false,
    guid: '',
  },
  serverPort: 80
};
